import { faStar } from "@jewlr/pro-regular-svg-icons/faStar"
import { faStar as solidStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalfAlt as solidStarHalf } from "@jewlr/pro-solid-svg-icons/faStarHalfAlt"
import PropTypes from "prop-types"

import withReviews from "areas/product/hoc/with-reviews"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { roundToHalf } from "helpers/round-to-half"
import { cn } from "styles/utils"

const StyledStar = ({ className = "", ...props }) => (
  <FontAwesomeIcon
    className={cn("text-rating text-12 mr-2", className)}
    {...props}
  />
)

StyledStar.propTypes = {
  className: PropTypes.string,
}

/**
 * Ratings/reviews component.
 *
 * @author [Adi Bakija]
 */
const InternalRatings = ({ handleClick, loading, ratings }) => {
  let displayReview = ratings?.average_score >= 4
  if (loading) return <div style={{ minHeight: "12px" }} />

  let starArray = []

  if (displayReview) {
    let average_rating = roundToHalf(ratings.average_score, 0.5)
    for (let i = 1; i <= 5; i++) {
      if (i <= average_rating) {
        starArray.push(<StyledStar icon={solidStar} key={i} />)
      } else if (i <= average_rating + 0.5) {
        starArray.push(<StyledStar icon={solidStarHalf} key={i} />)
      } else {
        starArray.push(<StyledStar icon={faStar} key={i} />)
      }
    }
  } else {
    for (let i = 1; i <= 5; i++) {
      starArray.push(
        <StyledStar className="text-grey-300" icon={solidStar} key={i} />
      )
    }
  }

  return (
    <Button
      className={cn(
        "text-14 leading-12 tablet:text-12 tablet:font-normal tablet:no-underline font-semibold"
      )}
      data-cy="product-rating"
      onClick={handleClick}
      style={{ height: "12px" }}
      underline={!displayReview}
    >
      {starArray}
      <span className="tablet:text-primary tablet:ml-3 ml-8 text-black">
        {displayReview ? `${ratings.total_review} reviews` : "Write a Review"}
      </span>
    </Button>
  )
}

InternalRatings.propTypes = {
  handleClick: PropTypes.func,
  loading: PropTypes.bool,
  ratings: PropTypes.object,
}
StyledStar.propTypes = {
  className: PropTypes.string,
}
export default withReviews(InternalRatings)
